// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getOptionAnswers as listOptionAnswersAPI,
    getOptionAnswer as getOptionAnswerAPI,
    addOptionAnswer as addOptionAnswerAPI,
    updateOptionAnswer as updateOptionAnswerAPI,
    deleteOptionAnswer as deleteOptionAnswerAPI,
} from '../../helpers/';

import { optionAnswersApiResponseError, optionAnswersApiResponseSuccess } from './actions';
import { OptionAnswersActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getOptionAnswer({ payload: { id } }) {
    try {
        const response = yield call(getOptionAnswerAPI, id);
        const optionAnswerItem = response.data.data;
        yield put(optionAnswersApiResponseSuccess(OptionAnswersActionTypes.GET_OPTION_ANSWER, optionAnswerItem));
    } catch (error) {
        yield put(optionAnswersApiResponseError(OptionAnswersActionTypes.GET_OPTION_ANSWER, error));
    }
}

function* addOptionAnswer({ payload: optionAnswer }) {
    try {
        const response = yield call(addOptionAnswerAPI, { ...optionAnswer })
        const optionAnswerItem = response.data
        yield put(optionAnswersApiResponseSuccess(OptionAnswersActionTypes.ADD_OPTION_ANSWER, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersApiResponseError(OptionAnswersActionTypes.ADD_OPTION_ANSWER, error))
    }
}

function* updateOptionAnswer({ payload: optionAnswer }) {
    try {
        const response = yield call(updateOptionAnswerAPI, { ...optionAnswer })
        const optionAnswerItem = response.data.data
        yield put(optionAnswersApiResponseSuccess(OptionAnswersActionTypes.UPDATE_OPTION_ANSWER, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersApiResponseError(OptionAnswersActionTypes.UPDATE_OPTION_ANSWER, error))
    }
}
function* deleteOptionAnswer({ payload: { id } }) {
    try {
        const response = yield call(deleteOptionAnswerAPI, id)
        const optionAnswerItem = response.data.id
        yield put(optionAnswersApiResponseSuccess(OptionAnswersActionTypes.DELETE_OPTION_ANSWER, optionAnswerItem))
    } catch (error) {
        yield put(optionAnswersApiResponseError(OptionAnswersActionTypes.DELETE_OPTION_ANSWER, error))
    }
}

/**
 * List contactos
 */
function* listOptionAnswers({ payload: params }) {
    try {
        const response = yield call(listOptionAnswersAPI, { ...params });
        const listaOptionAnswers = response.data.data;
        yield put(optionAnswersApiResponseSuccess(OptionAnswersActionTypes.LIST_OPTION_ANSWERS, listaOptionAnswers));
    } catch (error) {
        yield put(optionAnswersApiResponseError(OptionAnswersActionTypes.LIST_OPTION_ANSWERS, error));
    }
}


export function* watchGetOptionAnswer(): any {
    yield takeEvery(OptionAnswersActionTypes.GET_OPTION_ANSWER, getOptionAnswer);
}

export function* watchListOptionAnswers(): any {
    yield takeEvery(OptionAnswersActionTypes.LIST_OPTION_ANSWERS, listOptionAnswers);
}

export function* watchAddOptionAnswer(): any {
    yield takeEvery(OptionAnswersActionTypes.ADD_OPTION_ANSWER, addOptionAnswer)
}
export function* watchUpdateOptionAnswer(): any {
    yield takeEvery(OptionAnswersActionTypes.UPDATE_OPTION_ANSWER, updateOptionAnswer)
}
export function* watchDeleteOptionAnswer(): any {
    yield takeEvery(OptionAnswersActionTypes.DELETE_OPTION_ANSWER, deleteOptionAnswer)
}


function* optionAnswersSaga(): any {
    yield all([
        fork(watchGetOptionAnswer),
        fork(watchListOptionAnswers),
        fork(watchAddOptionAnswer),
        fork(watchUpdateOptionAnswer),
        fork(watchDeleteOptionAnswer),
    ]);
}

export default optionAnswersSaga;
